import { BROWSER } from 'esm-env';
import type { SearchContext } from '@shared/types/types.ts';
import type { WidgetSpinnerData } from '@tilelist/application/core/WidgetSpinner.ts';
import type { WidgetSpinnerClient } from '@tilelist/components/promo-widget-spinner/WidgetSpinnerClient.ts';

export type { WidgetSpinnerData } from '@tilelist/application/core/WidgetSpinner.ts';

export type WidgetSpinnerRequest = {
    searchContext?: SearchContext;
    client: WidgetSpinnerClient;
};

export async function load({ client, searchContext }: WidgetSpinnerRequest): Promise<WidgetSpinnerData> {
    if (!searchContext) {
        return { html: '' };
    }
    const implicitContext = facetsFrom(searchContext.topNImplicit);
    const explicitContext = facetsFrom(searchContext.explicit);
    const html = await client.getPromoWidgetSpinner({
        request: {
            psr: searchContext.rule,
            pageType: searchContext.searchTerm ? 'ses' : 'pl',
            variationIds: searchContext.variationIds || [],
            implicitContext,
            explicitContext,
        },
        headers: {
            ...getBrowserHeaders(),
        },
    });
    return { html };
}

function facetsFrom(topNImplicit?: { [p: string]: string[] }) {
    if (!topNImplicit) {
        return [];
    }
    return Object.entries(topNImplicit).map(([attributeName, facetValues]) => ({
        attributeName,
        facetValues,
    }));
}

function getBrowserHeaders(): Record<string, string> {
    return BROWSER && window.location ? { 'x-genesis-url': window.location.toString() } : {};
}
